import { useState } from "react";
import type { CSSProperties, MouseEvent, ReactNode } from "react";
import type { Theme, FontPairing } from "@structurify/shared-types";

interface Props {
  children: ReactNode;
  theme: Theme;
  fonts: FontPairing;
  primary?: boolean;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  style?: CSSProperties;
}

export function QuietButton({ children, theme, fonts, primary, onClick, disabled, style }: Props) {
  const [hover, setHover] = useState(false);

  const base: CSSProperties = {
    fontFamily: fonts.sans,
    fontSize: 13,
    fontWeight: primary ? 500 : 450,
    letterSpacing: primary ? "-0.005em" : "0",
    padding: primary ? "11px 18px" : "9px 14px",
    border: `1px solid ${primary ? theme.ink : theme.rule}`,
    background: primary ? theme.ink : "transparent",
    color: primary ? theme.docPaper : theme.ink,
    borderRadius: 2,
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.4 : hover ? 1 : 0.92,
    transition: "all 200ms ease",
    transform: hover && !disabled ? "translateY(-0.5px)" : "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    ...style,
  };

  return (
    <button
      onClick={disabled ? undefined : onClick}
      style={base}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {children}
    </button>
  );
}
